.confetti-canvas {
    position: absolute;
    width: 100%;
    height: 600px;
    pointer-events: none;
    display: flex;
    align-self: center;
}
